import React, { FunctionComponent, ChangeEvent } from 'react';
import { Loading } from '../../atoms/loading';

type Props = {
  icon: string;
  noIconPersonImg: string;
  isShow: boolean;
  handleUploadIcon: (file: File) => void;
  fromPage: string;
  name: string;
  positions: string;
  personId: number;
  follows: number | null;
  twitter: string;
  instagram: string;
  xIcon: string;
  instagramIcon: string;
  file: File | '';
  onFileInputChange: (event: ChangeEvent<HTMLInputElement>) => void;
  fileInputRef: React.RefObject<HTMLInputElement>;
  resume: "" | File | { name: { url: string; } };
  jobResume: "" | File | { name: { url: string; } };
  handleOpenMemoModal?: () => void;
  isOneYearPassed: boolean
};

export const Presentation: FunctionComponent<Props> = ({
  icon,
  noIconPersonImg,
  isShow,
  handleUploadIcon,
  fromPage,
  name,
  positions,
  personId,
  follows,
  twitter,
  instagram,
  xIcon,
  instagramIcon,
  file,
  onFileInputChange,
  fileInputRef,
  resume,
  jobResume,
  handleOpenMemoModal,
  isOneYearPassed,
}) => {
  const hasContent = (target: string | null) => {
    return target !== '' && target !== null;
  };

  return (
    <div className="person__show__sidebar__top">
      <div className='person__show__sidebar__heading'>
        <div className="person__show__sidebar__heading--icon">
          {icon !== '' ? (
            <img src={icon} className="person__show__sidebar__heading--icon--img" alt="プロフィール写真" />
          ) : (
            <img src={noIconPersonImg} className="person__show__sidebar__heading--icon--img" alt="プロフィール写真" />
          )}
          {isShow && (
            <label className="person__show__sidebar__heading--icon--camera">
              <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="1" width="25" height="24" rx="12" fill="#19190F" />
                <rect x="0.5" y="1" width="25" height="24" rx="12" stroke="white" />
                <path d="M13 15.7081C13.6039 15.7081 14.1159 15.4969 14.5359 15.0744C14.956 14.6519 15.166 14.1369 15.166 13.5294C15.166 12.9219 14.956 12.407 14.5359 11.9845C14.1159 11.5619 13.6039 11.3507 13 11.3507C12.3961 11.3507 11.8841 11.5619 11.4641 11.9845C11.044 12.407 10.834 12.9219 10.834 13.5294C10.834 14.1369 11.044 14.6519 11.4641 15.0744C11.8841 15.4969 12.3961 15.7081 13 15.7081ZM13 14.914C12.6113 14.914 12.2847 14.781 12.0202 14.5149C11.7557 14.2489 11.6235 13.9204 11.6235 13.5294C11.6235 13.1385 11.7557 12.8099 12.0202 12.5439C12.2847 12.2778 12.6113 12.1448 13 12.1448C13.3887 12.1448 13.7153 12.2778 13.9798 12.5439C14.2443 12.8099 14.3765 13.1385 14.3765 13.5294C14.3765 13.9204 14.2443 14.2489 13.9798 14.5149C13.7153 14.781 13.3887 14.914 13 14.914ZM8.95142 17.5C8.68556 17.5 8.46053 17.4074 8.27632 17.2221C8.09211 17.0368 8 16.8104 8 16.543V10.5158C8 10.2484 8.09211 10.0221 8.27632 9.83677C8.46053 9.65147 8.68556 9.55883 8.95142 9.55883H10.5587L11.5324 8.5H14.4676L15.4413 9.55883H17.0486C17.3144 9.55883 17.5395 9.65147 17.7237 9.83677C17.9079 10.0221 18 10.2484 18 10.5158V16.543C18 16.8104 17.9079 17.0368 17.7237 17.2221C17.5395 17.4074 17.3144 17.5 17.0486 17.5H8.95142Z" fill="white" />
              </svg>
              <input type="file" ref={fileInputRef} onChange={onFileInputChange} accept=".jpg, .jpeg, .png, .JPG, .PNG" />
            </label>
          )}
          <Loading />
        </div>
        {!isShow && fromPage === 'scout' && !isOneYearPassed &&
          <ul className="person__show__sidebar__heading--list">
            <li className={`${resume && 'active'}`}>
              <span className="material-symbols-outlined logo">article_person</span>
              <p className="text">履歴書</p>
            </li>
            <li className={`${jobResume && 'active'}`}>
              <span className="material-symbols-outlined logo">lab_profile</span>
              <p className="text">職務経歴書</p>
            </li>
            <li className={`${instagram && 'active'}`}>
              <span className="logo"><i className="fab fa-instagram instagram"></i></span>
              <p className="text">Instagram</p>
            </li>
          </ul>
        }
        {fromPage !== 'scout' && (
          <div className="person__show__sidebar__heading--info">
            <p className="name">{name}</p>
            {positions && positions !== 'null' && (
              <div className="person__show__sidebar__heading--positions">
                <p className="text">{positions}</p>
              </div>
            )}
            <div className="info">
              {isShow && (
                <a
                  href={`/users/${personId}/followee`}
                  target="_blank"
                  className={`follow ${!isShow ? 'disabled' : ''}`}
                >
                  <span>{follows}</span>フォロー中
                </a>
              )}
              {!isOneYearPassed && (
                <p className="sns">
                  {hasContent(twitter) && (
                    <a href={`https://twitter.com/${twitter}`} target="_blank">
                      <img src={xIcon} alt="twitter" />
                    </a>
                  )}
                  {hasContent(instagram) && (
                    <a href={`https://www.instagram.com/${instagram}`} target="_blank">
                      <img src={instagramIcon} alt="instagram" />
                    </a>
                  )}
                </p>
              )}
            </div>
            {
              fromPage === 'companyShow' && handleOpenMemoModal && (
                <div className="person__show__details__sp-button">
                  <button
                    type="button"
                    className="person__show__details__sp-button--btn"
                    onClick={handleOpenMemoModal}
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 11.5V14H4.5L11.8733 6.62667L9.37333 4.12667L2 11.5ZM13.8067 4.69333C14.0667 4.43333 14.0667 4.01333 13.8067 3.75333L12.2467 2.19333C11.9867 1.93333 11.5667 1.93333 11.3067 2.19333L10.0867 3.41333L12.5867 5.91333L13.8067 4.69333Z" fill="#19190F" />
                    </svg>
                    <span>求職者メモを編集</span>
                  </button>
                </div>
              )
            }
          </div >
        )}
      </div >
      {fromPage !== 'scout' && fromPage !== 'companyPeople' && fromPage !== 'companyShow' && (
        <div className="what_is_request profile-setting-popup">
          <span className="material-symbols-outlined profile-setting-popup">help</span>
          <span className="what_is_request--text profile-setting-popup">プロフィール公開範囲について</span>
        </div>
      )}
    </div >
  );
};
